import { Avatar, Box, Typography } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import { apiUrlPrefix } from "../../../config";
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

const UserListComponent = ({ userInformation, isChatAdmin, index, chatId, currentUserAdmin }) => {

  const removeDiscussionMember = async (userId) => {
    const apiUrl = apiUrlPrefix + 'Discussion/removeDiscussionMember';

    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Users: [userId],
        Id: chatId,
      }),
    });

    if (!response.ok) {
      if (response.status === 403) {
        throw new Error('Invalid credentials or permissions.');
      }
      throw new Error('Network response was not ok');
    }
    return response.json();
  };
  return (
    <Box key={userInformation.id || index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 2 }}>
      <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2}}>
      <Avatar
        src={userInformation.profilePicture}
        alt="ProfilePicture"
        sx={{
          width: { xs: '50px', sm: '60px' },
          height: { xs: '50px', sm: '60px' },
        }}
      />

      <Typography
        variant="body1"
        sx={{ fontWeight: 'medium' }} // Removed mb: 1 and <br>
      >
        {userInformation.name}
      </Typography>
      </Box>

      {isChatAdmin ? <StarIcon sx={{ color: '#f57c00', ml: 'auto' }} /> : ''}

        <PersonRemoveIcon
          id="removeDiscussionMemberButton"
          variant="contained"
          color="none"
          onClick={() => {
            removeDiscussionMember(userInformation.id);
          }}
          sx={{ display: currentUserAdmin ? 'flex' : 'none', color: 'red', cursor: 'pointer', mr: 1 }}
        />
    </Box>
  );
}

export default UserListComponent;